const customerSegmentStatus = {
  InActive: 0,
  Active: 1,
  Deleted: 2,
  InProcess: 3
}

export default customerSegmentStatus
